// Global As-Of Date — persisted in localStorage, used across the portal
// This is the single source of truth for the pricing/valuation date.

const AS_OF_DATE_KEY = 'quantra_as_of_date';

function todayString(): string {
  return new Date().toISOString().split('T')[0];
}

export function getAsOfDate(): string {
  try {
    const saved = localStorage.getItem(AS_OF_DATE_KEY);
    if (saved && /^\d{4}-\d{2}-\d{2}$/.test(saved)) return saved;
    return todayString();
  } catch {
    return todayString();
  }
}

export function setAsOfDate(date: string): void {
  localStorage.setItem(AS_OF_DATE_KEY, date);
  // Dispatch a storage event so other components can react
  window.dispatchEvent(new CustomEvent('quantra-asofdate-change', { detail: date }));
}
